"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _Typography = require("../Typography");

var _muiSelectors = require("../../utilities/mui-selectors");

var _TextButton = _interopRequireDefault(require("../TextButton/TextButton.overrides"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["count", "iconName", "iconStyle", "label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledMuiTab = (0, _material.styled)(_material.Tab)(function (_ref) {
  var _$concat, _$concat2, _ref2;

  var theme = _ref.theme;
  return _ref2 = {}, (0, _defineProperty2.default)(_ref2, "&.".concat(_muiSelectors.classes.components.MuiTab.root), (_$concat2 = {}, (0, _defineProperty2.default)(_$concat2, "& > .".concat(_muiSelectors.classes.components.MuiIcon.root), {
    marginRight: "".concat(theme.spacing(2), " !important")
  }), (0, _defineProperty2.default)(_$concat2, "& > .".concat(_muiSelectors.classes.components.MuiTypography.root), {
    marginLeft: theme.spacing(2)
  }), (0, _defineProperty2.default)(_$concat2, "&.".concat(_muiSelectors.classes.states.MuiFocusVisible), _TextButton.default.MuiButton.root["&.".concat(_muiSelectors.classes.states.MuiFocusVisible)]), (0, _defineProperty2.default)(_$concat2, "&.".concat(_muiSelectors.classes.states.MuiSelected, ", &:hover, &:focus"), (_$concat = {}, (0, _defineProperty2.default)(_$concat, "& .".concat(_muiSelectors.classes.components.MuiTypography.root), {
    color: theme.palette.primary.main
  }), (0, _defineProperty2.default)(_$concat, "color", theme.palette.primary.main), _$concat)), (0, _defineProperty2.default)(_$concat2, "&.".concat(_muiSelectors.classes.components.MuiButtonBase.root), {
    flexDirection: "row",
    fontWeight: "bold"
  }), (0, _defineProperty2.default)(_$concat2, "&:not(:last-child)", {
    marginRight: theme.spacing(3)
  }), (0, _defineProperty2.default)(_$concat2, "backgroundColor", "#fff"), (0, _defineProperty2.default)(_$concat2, "boxShadow", theme.shadows[1]), (0, _defineProperty2.default)(_$concat2, "minWidth", "unset"), (0, _defineProperty2.default)(_$concat2, "padding", "0.71rem 0.6rem"), _$concat2)), (0, _defineProperty2.default)(_ref2, "&.".concat(_muiSelectors.classes.components.MuiTab.textColorInherit), {
    opacity: 1
  }), (0, _defineProperty2.default)(_ref2, "&.".concat(_muiSelectors.classes.components.MuiTab.labelIcon), {
    minHeight: "auto"
  }), _ref2;
});

var Tab = function Tab(_ref3) {
  var count = _ref3.count,
      iconName = _ref3.iconName,
      _ref3$iconStyle = _ref3.iconStyle,
      iconStyle = _ref3$iconStyle === void 0 ? "fa" : _ref3$iconStyle,
      label = _ref3.label,
      props = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMuiTab, _objectSpread({
    icon: iconName && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      iconName: iconName,
      iconStyle: iconStyle
    }),
    label: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [label, (count || count === 0) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography.Typography, {
        display: "inline",
        variant: "body2",
        children: ["(", count, ")"]
      })]
    })
  }, props));
};

var _default = Tab;
exports.default = _default;